export default __webpack_public_path__ + "static/pointer-down-2db6aa5003def46cb506e2db98e160a5.png";